var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.5,
    height: 10.5,
    viewBox: "0 0 10.5 10.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-image",
    "data-name": "Icon ionic-ios-image",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M7.664,14.54h4.813a.141.141,0,0,0,.114-.222l-2.408-3.872a.139.139,0,0,0-.23,0L7.548,14.318A.142.142,0,0,0,7.664,14.54Z",
    transform: "translate(-2.659 -4.494)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M21.52,16.042l.883,1.406a.137.137,0,0,0,.114.061H23.86a.141.141,0,0,0,.114-.222l-1.555-2.214a.139.139,0,0,0-.23,0l-.671.81A.146.146,0,0,0,21.52,16.042Z",
    transform: "translate(-11.616 -7.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M23.3,9.288a.707.707,0,1,0-.775-.775A.709.709,0,0,0,23.3,9.288Z",
    transform: "translate(-12.272 -2.887)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M13.067,3.375H4.183a.807.807,0,0,0-.808.808v8.885a.807.807,0,0,0,.808.808h8.885a.807.807,0,0,0,.808-.808V4.183A.807.807,0,0,0,13.067,3.375ZM13,10.442a.2.2,0,0,1-.2.2H4.453a.2.2,0,0,1-.2-.2V4.453a.2.2,0,0,1,.2-.2H12.8a.2.2,0,0,1,.2.2v5.99Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.97c7399ab01f47e12bedbe370de9518b.svg";
export { ForwardRef as ReactComponent };